import { AfterViewInit, ChangeDetectorRef, Component, inject, OnInit, ViewChild } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { OrderFormComponent } from 'src/app/patients/dashboard-page/provider-charts-tab/provider-orders-tab/order-form/order-form.component';
import { ProviderOrder } from 'src/app/calvin-emr-shared/models/provider-order.model';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-order-edit-dialog',
  templateUrl: './order-edit-dialog.component.html',
  styleUrls: ['./order-edit-dialog.component.scss'],
  standalone: true,
  imports: [
    ButtonDirective,
    OrderFormComponent,
  ],
})
export class OrderEditDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('orderForm') providerOrderForm!: OrderFormComponent;

  public ref = inject(DynamicDialogRef);
  public config = inject(DynamicDialogConfig);
  private cdRef = inject(ChangeDetectorRef);

  type: string;
  order: ProviderOrder | undefined;
  forOrderSet: boolean;

  constructor() {
    this.type = this.config.data.type;
    this.order = this.config.data.order;
    this.forOrderSet = this.config.data.forOrderSet;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges();
  }

  closeDialog(): void {
    this.ref.close();
  }

  /**
   * Submit the order form and send the order data to the patient component
   */
  onSubmit() {
    this.order = this.providerOrderForm.createOrderFromForm({ partOfOrderSet: this.forOrderSet });
    this.ref.close(this.order);
  }

  get btnLabel() {
    return this.type === 'create' ? 'Create' : 'Update';
  }

  get isFormValid() {
    if (this.providerOrderForm !== undefined && this.providerOrderForm !== null) {
      return this.providerOrderForm.form.valid;
    }
    return false;
  }
}
